<template>
  <form @submit.prevent>
    <CModal :title.sync="title" color="info" :show.sync="show">
      <!-- <p style="color:blue;">Resolusi gambar sebaiknya 2:1 | contoh 600x300 / 1568x784</p> -->
      <b-form-file
        size="sm"
        v-model="form.file"
        class="mt-3"
        plain
      ></b-form-file>
      <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton
          v-if="mode === 'edit'"
          type="submit"
          v-on:click.prevent="upload()"
          variant="outline"
          color="info"
          >Upload</CButton
        >
      </template>
    </CModal>
  </form>
</template>

<script>
import moment from "moment";

import EventBus from "@/eventBus";

import linkcontent from "@/services/linkcontent";

export default {
  name: "modalphoto",

  data() {
    return {
      show: false,
      title: "Default Title",
      mode: "",
      form: {
        file: "",
      },
      key: "",
      id: "",
    };
  },
  mounted() {},

  created() {
    var self = this;
    EventBus.$on("OPEN_MODAL_EVENT_PHOTO_BGIMAGE_LINKCONTENT", (params) => {
      if (params.data) {
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.key = params.data;
        self.id = params.data;
      } else {
      }
    });
  },

  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    upload() {
      let formData = new FormData();
      formData.append("file", this.form.file);

      this.show = false;
      linkcontent
        .updateBGImage(this.id, formData)
        .then((res) => {
          EventBus.$emit("TABLE_UPDATE", true);
          var params = { title: "Success", mode: "success", data: res.message };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        })
        .catch((err) => {
          var params = {
            title: "Error",
            mode: "danger",
            data: err.response.data.message,
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        });
      console.log("get photo");
    },

    getImage(url) {
      if (url) {
        //url = url.replace('https://x.ifgfsby.org','http://localhost:8005');
        return url;
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
